'use client';
import { SystemMessage } from '@shared/components/SystemMessage';
export const SomethingWentWrong = ({ goBackHref, reset }) => {
    return <SystemMessage message='Something went wrong' goBackHref={goBackHref} reset={reset}/>;
};
//# sourceMappingURL=SomethingWentWrong.jsx.map